export const percentFormatter = (params: { value: number | null }) => {
  if (params.value === null) {
    return '';
  }
  const percentage = (params.value * 100).toFixed(2);
  return `${percentage}%`;
};
